import React from 'react'
import PaymentList from './PaymentList'
import Payment from './Payment'
import { Route, Routes } from 'react-router-dom';
import ViewPayment from './ViewPayment';
import VendorPayment from './VendorPayment';

export default function PaymentRoute() {
     return (
          <Routes>
               <Route path="/" element={<PaymentList />} />
               <Route path="/customerPayment" element={<Payment />} />  
               <Route path="/vendorPayment" element={<VendorPayment />} />  
               <Route path="/view/:id" element={<ViewPayment />} />  
          </Routes>
     )
}
